import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { trackService } from "./trackService";

// Updated thunk to accept latitude, longitude, and socketId
export const trackVisitor = createAsyncThunk(
  "track/trackVisitor",
  async ({ latitude, longitude, socketId } = {}, thunkAPI) => {
    try {
      return await trackService.trackVisit({ latitude, longitude, socketId });
    } catch (error) {
      const message =
        (error.response?.data?.message) || error.message || "Failed to track visitor";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  visitor: null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

export const trackSlice = createSlice({
  name: "track",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(trackVisitor.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(trackVisitor.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.visitor = action.payload;
      })
      .addCase(trackVisitor.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export default trackSlice.reducer;
